module.exports = __webpack_public_path__ + "img/affiliate-settings.2fea73ca.svg";